var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 100,
    viewBox: "0 0 73 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4054 36.118L37.4046 45.4297L28.1213 26.6969L32.917 15.9259C34.1291 13.7774 36.1114 13.749 37.3235 15.9259L47.4054 36.118Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4088 45.4256L0 80.2197L28.1256 26.6969L37.4088 45.4256Z",
    fill: "#F57F17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3712 21.877C60.163 20.1703 62.0075 20.746 62.4736 23.1702L72.1988 79.7496L39.9424 99.1148C38.8114 99.7472 35.8116 99.9945 35.8116 99.9945C35.8116 99.9945 33.0833 99.6621 32.0375 99.0864L0 80.2198L58.3712 21.877Z",
    fill: "#FFCA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1255 26.697L0 80.2197L12.5345 1.98888C13.0047 -0.435314 14.379 -0.682597 15.6194 1.46593L28.1255 26.697Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase1);
export default __webpack_public_path__ + "static/media/firebase1.a612919d5c8e87c4f40fc38909a03758.svg";
export { ForwardRef as ReactComponent };